import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo, eventInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-slate-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-12 mb-8">
            {/* Company Info */}
            <div>
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-10 mb-4"
              />
              <p className="text-gray-400 text-sm leading-relaxed">
                Profesionální cateringové služby pro vaše nezapomenutelné akce.
              </p>
            </div>
            
            {/* Contact */}
            <div>
              <h4 className="text-lg font-bold mb-4">Kontakt</h4>
              <div className="space-y-3 text-sm">
                <a
                  href={`tel:${companyInfo.contact.phone}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-cyan-400 transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  <span>{companyInfo.contact.phone}</span>
                </a>
                <a
                  href={`mailto:${companyInfo.contact.email}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-cyan-400 transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  <span>{companyInfo.contact.email}</span>
                </a>
              </div>
            </div>
            
            {/* Event Info */}
            <div>
              <h4 className="text-lg font-bold mb-4">Akce</h4>
              <div className="text-sm text-gray-400 space-y-2">
                <p className="font-semibold text-white">{eventInfo.title}</p>
                <p>{eventInfo.client}</p>
                <p>{eventInfo.date}</p>
                <p className="text-xs">{eventInfo.location}</p>
              </div>
            </div>
          </div>
          
          {/* Additional Info */}
          <div className="border-t border-gray-800 pt-8 mb-6">
            <div className="bg-gradient-to-r from-cyan-900/30 to-blue-900/30 rounded-lg p-6 text-center border border-cyan-800/30">
              <h4 className="text-lg font-bold mb-3 text-cyan-300">📦 Kompletní inventář a mobiliář</h4>
              <p className="text-gray-300 text-sm leading-relaxed mb-4">
                Disponujeme kompletním inventářem a mobiliářem pro realizaci vaší akce. 
                V případě zájmu nabízíme pronájem nábytku, stanů, osvětlení a dalšího vybavení.
              </p>
              <a
                href="https://vseproakci.cz/sluzby/pronajem-vybaveni/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-cyan-400 hover:text-cyan-300 transition-colors font-medium text-sm"
              >
                Zobrazit kompletní nabídku pronájmu →
              </a>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-500 text-sm">
              © {currentYear} {companyInfo.fullName}. Vytvořeno pro {eventInfo.client}
            </p>
            <p className="text-gray-600 text-xs mt-2">
              Tato nabídka je platná do 31. 5. 2026
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
